// extracted by mini-css-extract-plugin
export default {"paymentHistoryTable":"DbrZAmQa4DRnVxmMnrFw","searchInput":"bykC8edu3HvrIEpIDzN9","staticOnScroll":"VJcb2iufrmiy07e90pPg"};